export default __webpack_public_path__ + "static/src/assets/images/icons/mobiles/icon_editwatchlist@2x.png";